/**
 * Created by saltrichter.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/notificationTab/NotificationItemView.tmpl"),
        NotificationListItemView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        NotificationListItemView = Marionette.ItemView.extend({
            template: template,
            className: 'notification-view',
            region:{
            },
            ui: {
                "notificationIcon": ".notification-sub-container .notification-icon",
                "notificationTitle": ".notification-sub-container .notification-item-title",
                "notificationDescription": ".notification-sub-container .notification-item-description",
                "notificationRemove": ".notification-item-remove",
                "notificationContainer": ".notification-container",
                "notificationSubContainer": ".notification-sub-container"
            },
            events: {
                'click @ui.notificationSubContainer': "_onClick",
                'click @ui.notificationRemove': "_onRemoveClick"
            },

            initialize: function(){
                this.notificationTabChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.NOTIFICATION_TAB);
            },

            onRender: function () {
                if(this.model.isRead()){
                    this._setItemRead();
                }
                if(this.model.isDeleted()){
                    this._hideItem();
                }
                // this is done, because if we have an updated service status report, we will set this one as read if it is already read.
                this.listenTo(this.model, 'change:isRead', this._setItemRead);
                this.listenTo(this.model, 'change:isDeleted', this._hideItem);
                this.listenTo(this.model, 'change:timeAgoReceived', this.render);
            },

            _onModelChange: function(model){
                if(model.changed.isRead === true){
                    this._setItemRead();
                }
            },

            _onClick: function(){
                this.model.setItemRead();
                this.notificationTabChannel.vent.trigger("NotificationTabController::notification:display",this.model);
            },

            _onRemoveClick: function(){
                this.notificationTabChannel.vent.trigger("NotificationTabController::notification:remove",this.model, false);
            },

            setSelected: function(id){
                if (id && this.model.get("id") === id) {
                    if(this._isSelected()){
                        this._unSelect();
                    }else{
                        this._select();
                    }
                }
                else {
                    this._unSelect();
                }
            },

            _isSelected: function () {
                return this.ui.notificationContainer.hasClass('is-selected');
            },

            _unSelect: function () {
                this.ui.notificationContainer.removeClass("is-selected");
            },

            _select: function () {
                this.ui.notificationContainer.addClass("is-selected");
            },

            _setItemRead: function(model, isRead){
                if (isRead || _.isUndefined(isRead)) {
                    this.ui.notificationContainer.addClass("is-read");
                } else {
                    this.ui.notificationContainer.removeClass("is-read");
                }
            },

            _hideItem: function (model, isDeleted) {
                if (isDeleted || _.isUndefined(isDeleted)) {
                    this.$el.hide();
                } else {
                    this.$el.show();
                }
            }
        });
});
    return NotificationListItemView;
});
